var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSede(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#831131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172,152.5V24.5l-0.6-0.5c-0.3-0.2-30.7-22.1-74.2-22.2l0,1.5l-0.1-1.5H97C53.5,2,23.2,23.8,22.9,24l-0.6,0.5v128.1h-2.4   V184h28.5v-3.3h22.3V74.1c4.5-2,27-10.9,55,0.1v104.8h21.3v5.2h28.4v-31.5L172,152.5L172,152.5z M25.2,26   c4.5-3,32.6-21.1,71.8-21.2h0.1C136.3,4.9,164.5,23,169,26v126.2h-16.9V36.5l-0.8-0.4c-16.4-8.8-34.7-13.3-54.2-13.4   c-19.5,0.1-37.7,4.6-54.2,13.4l-0.8,0.4v115.9c-1.9,0-5.2,0.1-8.6,0.1h-8.3L25.2,26L25.2,26z M45.3,181.1H22.8v-25.4h0.9   c0.6,0,5.2-0.1,9.8-0.1h11.7L45.3,181.1L45.3,181.1z M149.1,152.5H147v23.4h-18.4V72.1l-0.9-0.4c-33.1-13.4-58.2-0.5-59.3,0.1   l-0.8,0.4v105.5H48.3v-25.2h-3.1V38.3c15.8-8.3,33.3-12.5,52-12.6c18.7,0.1,36.2,4.3,52,12.6V152.5z M172.4,181.1H150v-25.5h22.4   V181.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.4,
    y: 195.3,
    width: 59.5,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.3,
    y: 194,
    width: 14.2,
    height: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSede);
export default __webpack_public_path__ + "static/media/sede.bd2ab4c041a46065344a58731e97f6b0.svg";
export { ForwardRef as ReactComponent };